import { useDispatch } from "react-redux";
import { logoutUser } from "../Store/reducers/Users";
import { setInitialLoader } from "../Store/reducers/Common";
import { setToastData, setToastDisplay } from "../Store/reducers/Toast";
import { useNavigate } from "react-router-dom";
import { AuthLogin } from "./Auth";
import { useEffect } from "react";
export const ToastTemplate = ({ toggleToast, toastData, activeClass }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const logoutOtherDevices = async (email, ip) => {
		if (window.confirm("Do you want to logout from all devices?")) {
			dispatch(setToastDisplay(false));
			dispatch(setInitialLoader(true));
			fetch(`${process.env.REACT_APP_API_URL}web/logout`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					logout_everwhere: 1,
					email: email,
					ip: ip,
				}),
			})
				.then((res) => res.json())
				.then((response) => {
					if (response.code === 400) {
						dispatch(
							setToastData({
								message: `${response.message}`,
								isHtml: true,
								type: "error",
								showCloseBtn: true,
							})
						);
					} else {
						dispatch(
							setToastData({
								message: `${response.message}`,//, redirecting you in a moment!
								isHtml: true,
								type: "success",
								showCloseBtn: true,
							})
						);
						AuthLogin(response.token, dispatch, () => {
							navigate(`/`);
						});
					}
					dispatch(setInitialLoader(false));
				})
				.catch((err) => {
					dispatch(
						setToastData({
							message: `${err.message}`,
							isHtml: true,
							type: "error",
							showCloseBtn: true,
						})
					);
					dispatch(setInitialLoader(false));
				});
		}
	};
	useEffect(() => {
		if (typeof toastData.tooManyLogin === "undefined" || toastData.tooManyLogin === false) {
			if (typeof toastData.showLogoutBtn === "undefined" || toastData.showLogoutBtn === false) {
				if (typeof toastData.showOkBtn === "undefined" || toastData.showOkBtn === false) {
					if (toastData.type !== "warning" && toastData.type !== "error") {
						//setTimeout(()=>{toggleToast();},2000);
					}
				}
			}
		}
	}, [toastData])
	return (
		<div className={`popup-notify ${activeClass}`}>
			<div className="notify-container popup-outer">
				<div className="notify-header">
					{
						toastData.showCloseBtn &&
						<button
							className="close-notify"
							onClick={() => {
								toggleToast();
							}}
						>
							<i className="fas fa-times"></i>
						</button>
					}
				</div>
				<div className="notify-body">
					<div className="notify-img">
						{toastData.type === "success" && (
							<i className="fa-solid fa-circle-check"></i>
						)}
						{toastData.type === "error" && (
							<i className="fa-solid fa-circle-xmark"></i>
						)}
						{toastData.type === "warning" && (
							<i className="fa-solid fa-triangle-exclamation"></i>
						)}
					</div>
					{
						toastData.isHtml ? <h3 dangerouslySetInnerHTML={{ __html: toastData.message }} /> : <h3>{toastData.message}</h3>
					}
					{
						(typeof toastData.showOkBtn === "undefined" || toastData.showOkBtn === true) && <div className="text-center">
							<button onClick={() => { toggleToast(); }} className="btn btn-blue">Okay</button>
						</div>
					}
					{
						toastData.showLogoutBtn === true && <div className="text-center btm-pp-btn">
							<button onClick={() => { dispatch(logoutUser()) }} className="btn btn-blue btn-pp-other-btn mt-3">Logout</button>
						</div>
					}
					{
						toastData.tooManyLogin === true && <div className="text-center btm-pp-btn"> <button
							className="btn btn-blue btn-pp-other-btn mt-3"
							onClick={() => logoutOtherDevices(toastData.email, toastData.ip)}
							type="button"
						>
							Logout from everywhere else
						</button></div>
					}
				</div>
			</div>
		</div>
	)
}